
async function getSectionLabel(productId) {
    try {
        var data = productId;
        var url1 = "https://us-central1-bi-master-project.cloudfunctions.net/get_ma_product_labels_au";
        const result = await $.ajax({
            type: "POST",
            url: url1,
            dataType: 'json',
            data: data
        });
        return result;
    } catch (error) {
        return {};
    }
}